export default __webpack_public_path__ + "static/sunsoaked-banner-mobile-9e1ec76f10c333a9e0d6011d3841c04f.webp";